export default "__VITE_ASSET__652ca856__"